package com.shadowings.gero.presentation.component

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Surface
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarScrollBehavior
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.DevicePreviews
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import gero.composeapp.generated.resources.F34
import gero.composeapp.generated.resources.N14
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.U28
import gero.composeapp.generated.resources.Y1
import gero.composeapp.generated.resources.top_bar_coin_desc
import gero.composeapp.generated.resources.top_bar_fire_desc
import gero.composeapp.generated.resources.top_bar_heart_desc
import gero.composeapp.generated.resources.top_bar_star_desc
import org.jetbrains.compose.resources.stringResource

enum class StatType {
    STRIKE, STAR, LEVEL, HEART
}

@OptIn(ExperimentalMaterial3Api::class)
@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun TopBarPreview() {
    AppTheme {
        Surface {
            Column {
                TopBar(0, 1, 3, 12)
                TopBar(365, 5, 5, 6)
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TopBar(
    strikeCount: Int,
    level: Int,
    starCount: Int,
    heartsCount: Int,
    showHearts: Boolean = true,
    hasAvailableStreakRestoration: Boolean = false,
    onStatClick: (StatType) -> Unit = {},
    onBackClick: (() -> Unit)? = null,
    scrollBehavior: TopAppBarScrollBehavior? = null
) {
    val deviceInfo = rememberDeviceInfo()
    val iconSize = if (deviceInfo.deviceClass == DeviceClass.WEB_FULL) 52.dp else 24.dp
    TopAppBar(
        modifier = Modifier.semantics { testTag = "top_bar" },
        navigationIcon = {
            if (onBackClick != null) {
                BackIconButton(onBackClick = onBackClick, testTagId = "top_bar_btn_back")
            }
        },
        title = {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                TopBarTag(
                    Modifier.weight(1f).clickable { onStatClick(StatType.LEVEL) }
                        .semantics { testTag = "top_bar_stat_level" },
                    image = Res.drawable.Y1,
                    description = stringResource(Res.string.top_bar_coin_desc),
                    count = level,
                    iconSize = iconSize
                )
                TopBarTag(
                    Modifier.weight(1f).clickable { onStatClick(StatType.STRIKE) }
                        .semantics { testTag = "top_bar_stat_strike" },
                    image = Res.drawable.U28,
                    description = stringResource(Res.string.top_bar_fire_desc),
                    count = strikeCount,
                    iconSize = iconSize,
                    showBadge = hasAvailableStreakRestoration
                )
                TopBarTag(
                    Modifier.weight(1f).clickable { onStatClick(StatType.STAR) }
                        .semantics { testTag = "top_bar_stat_star" },
                    image = Res.drawable.N14,
                    description = stringResource(Res.string.top_bar_star_desc),
                    count = starCount,
                    iconSize = iconSize
                )
                if (showHearts && heartsCount < 999) {
                    TopBarTag(
                        Modifier.weight(1f).clickable { onStatClick(StatType.HEART) }
                            .semantics { testTag = "top_bar_stat_heart" },
                        image = Res.drawable.F34,
                        description = stringResource(Res.string.top_bar_heart_desc),
                        count = heartsCount,
                        iconSize = iconSize
                    )
                }
            }
        },
        scrollBehavior = scrollBehavior
    )
}


